import React from "react";
import "./SelectedLocationPanel.scss";
import { LocationInfo } from "../../shared/models/Location";

const SelectedLocationPanel = (props: React.PropsWithChildren<any>) => {
  return (
    <div className="col-md-4" id="selected-location-panel">
      <div className="card mb-5 shadow">
        <div className="panel-header">
          <div className="card-title panel-title">
            <div>
              <i className="fas fa-map-marker-alt pr-1" />
              {props.location.title}
            </div>
          </div>
        </div>

        <div className="card card-body panel-content">
          <span>Weststar Mortgage Corporation</span>
          {props.location.address} <br />
          {props.location.address2} <br />
          {props.location.city}, {props.location.state} {props.location.zip}
          <span style={{ paddingTop: "4px" }}>{props.location.phone}</span>
          <span style={{ paddingTop: "4px" }}>{props.location.phone2}</span>
          <span style={{ paddingTop: "4px" }}>{props.location.email}</span>
          <span style={{ paddingTop: "4px" }}>License/Registration:</span>
          <span style={{ paddingTop: "4px" }}>
            {props.location.license.map((license: LocationInfo) => (
              <>
                <span style={{ paddingLeft: "8px" }}>{license}</span>
                <br />
              </>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SelectedLocationPanel;
